import { ReplyFormWrapper } from './styled';
import { FaRegComments, FaAngleDown, FaAngleUp, FaShare } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from 'redux/selector';
import { useState } from 'react';
import { rattingCommentActions } from 'redux/slice/rattingCommentSlice';

const ReplyForm = ({ data, replyList, callBack, isReply = false, seeMore, setSeeMore }) => {
    const authState = useSelector(authSelector)
    const navigate = useNavigate()
    const location = useLocation();
    const pathname = location.pathname;
    const [inputReply, setInputReply] = useState("")
    const [error, setError] = useState("")
    const dispatch = useDispatch()
    const [showForm, setShowForm] = useState(false)
    const handleSentRatting = () => {
        if (!authState.isLoggedIn) return navigate("/login", { state: { pathname } });
        if (inputReply.trim().length > 12) {
            setError("")
            const payload = {
                tour_id: data.tour_id,
                content: inputReply.trim(),
                parent_id: data.id,
            }
            dispatch(rattingCommentActions.create({ data: payload, callBack, setInputReply, isRate: false }))
            setShowForm(false)

        } else {
            setError("Nhập bình luận tối thiểu 12 ký tự")
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSentRatting();
        }
    };
    return (
        <ReplyFormWrapper>
            <div className="control">
                {
                    !isReply &&
                    <div
                        className="flex-space"
                    >
                        <span onClick={() => setShowForm(!showForm)}><FaRegComments className="text-link clickable" /></span>
                        {
                            replyList.length > 0 &&
                            <span className="text-link flex clickable"
                                onClick={() => setSeeMore(!seeMore)}
                            >
                                <span>
                                    {seeMore ? "Ẩn bình luận" : `Xem thêm ${replyList.length} bình luận`}
                                </span>
                                {
                                    !seeMore &&
                                    <FaAngleDown className="ml-5" />
                                }
                                {
                                    seeMore &&
                                    <FaAngleUp className="ml-5" />
                                }
                            </span>
                        }
                    </div>
                }
                {
                    showForm && !isReply &&
                    <>
                        <div className="form_reply flex mt-10">
                            <input className="b-grey-1 px-5 py-5"
                                value={inputReply}
                                onChange={e => setInputReply(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                            <button
                                onClick={handleSentRatting}
                                className="clickable"
                            ><FaShare className="text-white s-18" /></button>
                        </div>
                        <p className="mt-5 text-red">{error}</p>
                    </>
                }
            </div>
        </ReplyFormWrapper >
    )
}

export default ReplyForm